import React from 'react';
import { useTranslation } from '../contexts/TranslationContext';

const Datenschutz = () => {
    const { t } = useTranslation();

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Header */}
            <div className="bg-white border-b border-gray-200 pt-24">
                <div className="container-custom py-16">
                    <div className="max-w-3xl">
                        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                            {t('privacy.title')}
                        </h1>
                        <p className="text-xl text-gray-600 leading-relaxed">
                            {t('privacy.description')}
                        </p>
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="container-custom py-16">
                <div className="max-w-4xl mx-auto">
                    <div className="bg-white rounded-2xl border border-gray-200 p-8 md:p-12">
                        <div className="space-y-8">
                            {/* Data Controller */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    1. {t('privacy.dataController')}
                                </h3>
                                <div className="text-gray-600 leading-relaxed whitespace-pre-line">
                                    {t('privacy.dataControllerText')}
                                </div>
                            </section>

                            {/* Data Processing */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    2. {t('privacy.dataProcessing')}
                                </h3>
                                <div className="text-gray-600 leading-relaxed whitespace-pre-line">
                                    {t('privacy.dataProcessingText')}
                                </div>
                            </section>

                            {/* Data Types */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    3. {t('privacy.dataTypes')}
                                </h3>
                                <div className="text-gray-600 leading-relaxed whitespace-pre-line">
                                    {t('privacy.dataTypesText')}
                                </div>
                            </section>

                            {/* Legal Basis */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    4. {t('privacy.legalBasis')}
                                </h3>
                                <div className="text-gray-600 leading-relaxed whitespace-pre-line">
                                    {t('privacy.legalBasisText')}
                                </div>
                            </section>

                            {/* Data Sharing */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    5. {t('privacy.dataSharing')}
                                </h3>
                                <div className="text-gray-600 leading-relaxed whitespace-pre-line">
                                    {t('privacy.dataSharingText')}
                                </div>
                            </section>

                            {/* Data Transfer */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    6. {t('privacy.dataTransfer')}
                                </h3>
                                <p className="text-gray-600 leading-relaxed">
                                    {t('privacy.dataTransferText')}
                                </p>
                            </section>

                            {/* Data Retention */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    7. {t('privacy.dataRetention')}
                                </h3>
                                <div className="text-gray-600 leading-relaxed whitespace-pre-line">
                                    {t('privacy.dataRetentionText')}
                                </div>
                            </section>

                            {/* Security */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    8. {t('privacy.security')}
                                </h3>
                                <div className="text-gray-600 leading-relaxed whitespace-pre-line">
                                    {t('privacy.securityText')}
                                </div>
                            </section>

                            {/* Your Rights */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    9. {t('privacy.yourRights')}
                                </h3>
                                <div className="text-gray-600 leading-relaxed whitespace-pre-line">
                                    {t('privacy.yourRightsText')}
                                </div>
                            </section>

                            {/* Cookies */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    10. {t('privacy.cookies')}
                                </h3>
                                <div className="text-gray-600 leading-relaxed whitespace-pre-line">
                                    {t('privacy.cookiesText')}
                                </div>
                            </section>

                            {/* Automated Processing */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    11. {t('privacy.automated')}
                                </h3>
                                <p className="text-gray-600 leading-relaxed">
                                    {t('privacy.automatedText')}
                                </p>
                            </section>

                            {/* Minors */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    12. {t('privacy.minors')}
                                </h3>
                                <p className="text-gray-600 leading-relaxed">
                                    {t('privacy.minorsText')}
                                </p>
                            </section>

                            {/* Updates */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    13. {t('privacy.updates')}
                                </h3>
                                <p className="text-gray-600 leading-relaxed">
                                    {t('privacy.updatesText')}
                                </p>
                            </section>

                            {/* Contact */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    14. {t('privacy.contact')}
                                </h3>
                                <div className="text-gray-600 leading-relaxed whitespace-pre-line">
                                    {t('privacy.contactText')}
                                </div>
                            </section>

                            {/* Complaints */}
                            <section>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                                    15. {t('privacy.complaints')}
                                </h3>
                                <div className="text-gray-600 leading-relaxed whitespace-pre-line">
                                    {t('privacy.complaintsText')}
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Datenschutz;